module.exports = __webpack_public_path__ + "static/media/Photo5.f7b754cd.jpg";